/**
 * Created by why on 2019/10/21.
 */
import {
  getByCondition,
  save,
  edit,
  delByIds,
  getAll
} from '@/api/i18n-manage'

export default {
  state: {
    list: [],
    i18nLoading: false,
    loadingSave: false,
    pageSize: 10,
    pageNum: 1,
    total: 0
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setI18nLoading (state, loading) {
      state.i18nLoading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
    setLoadingSave (state, loadingSave) {
      state.loadingSave = loadingSave
    }
  },
  getters: {
    i18nList: state => state.list,
    i18nTotal: state => state.total,
    i18nLoading: state => state.i18nLoading,
    i18nLoadingSave: state => state.loadingSave
  },
  actions: {
    getI18nByCondition ({ state, commit }, data) {
      commit('setI18nLoading', true)
      return new Promise((resolve, reject) => {
        getByCondition(data).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setList', list)
          commit('setI18nLoading', false)
          commit('setPageSize', pageSize)
          commit('setPageNum', pageNum)
          commit('setTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setI18nLoading', false)
          reject(err)
        })
      })
    },
    getI18nAll () {
      return new Promise((resolve, reject) => {
        getAll().then(res => {
          const data = res.data.result
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    i18nInsert ({ state, commit }, data) {
      commit('setLoadingSave', true)
      return new Promise((resolve, reject) => {
        save(data).then(res => {
          commit('setLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setLoadingSave', false)
          reject(err)
        })
      })
    },
    i18nDelByIds ({ state, commit }, ids) {
      return new Promise((resolve, reject) => {
        delByIds(ids).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    i18nEdit ({ state, commit }, data) {
      commit('setLoadingSave', true)
      return new Promise((resolve, reject) => {
        edit(data).then(res => {
          commit('setLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setLoadingSave', false)
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/i18n-manage.js